import {createApp, ref} from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import { router } from './router'
import cookies from 'vue3-cookies'
import {auth} from "@/common/auth";
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import VueYandexMetrika from 'vue3-yandex-metrika'
import {CONFIG} from "@/common/config";


loadFonts()

let isAuthorized = ref(auth.isAuthorized())
function switchState () {
    isAuthorized.value = auth.isAuthorized()
}

createApp(App)
    .use(vuetify)
    .use(router)
    .use(cookies, {
        expireTimes: "30d",
        path: "/",
        domain: "",
        secure: true,
        sameSite: "None"
    })
    .use(VueYandexMetrika, {
        id: CONFIG.YANDEX_METRIKA_CODE,
        router: router,
        env: process.env.NODE_ENV,
        debug: true
    })
    .provide('authorization', {
        isAuthorized,
        switchState
    })
    .mount('#app')
